export default function ProgressNote({ label, value, pct, className = '' }: { label: React.ReactNode, value: React.ReactNode, pct: number, className?: string }) {
  return (
    <div className={className}>
      <div className="flex items-baseline justify-between gap-4 text-[13px]">
        <span>{label}</span>
        <span className="shrink-0 text-muted-foreground tabular-nums">{value}</span>
      </div>
      <div className="mt-2 h-0.5 bg-border">
        <div className="h-full bg-foreground transition-[width] duration-500 motion-reduce:transition-none" style={{ width: `${Math.max(0, Math.min(pct, 100))}%` }} />
      </div>
    </div>
  )
}
